import * as React from 'react';
import { useTheme } from '../../../theme';

const SummaryHeader: React.FC = ({ children }) => {
	const theme = useTheme('PaymentForm').Summary;

	return <div className={theme.header}>{children}</div>;
};

export default SummaryHeader;
